
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/companyPolicy',['Vue', 'vue!../reusableComponents/segment'],function(Vue, segment){
        return {
            name:'companyPolicy',
            template:template,
            components: {
                segment: segment,
            },
            computed: {
                venueDetails: function() {
                    return this.$store.state.pmsCheckin.venueDetails
                }
            }
        }
    })
})('<segment v-if="!!venueDetails.SetupRegCardFooter"> <template v-slot:header> <i class="fas fa-file-contract"></i> {{localization.roomReservation.pmsCheckIn.companyPolicyLabel}} </template> <template v-slot:body> <span v-html="getMarkdownHTML(venueDetails.SetupRegCardFooter)"></span> </template> </segment>');
